import React, { memo, useState, useCallback, useEffect, useMemo, useContext } from 'react';
import { context } from '@gp/components/Context/index';
import { ContentType } from '../../index.d';
import { SortBy } from "tea-component/lib/table/addons";
import { useMemoizedFn } from 'ahooks';
// import { getLastMonthes } from '@gp/utils/common';
// import RangePicker from '@gp/components/RangePickerNew';
import RangePicker from '@gp/components/GeneralRangePicker';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import { FILE_TYPES2, FILE_TYPES_MAP } from '@gp/constants/const';
import {
  actionItemsListDownLoad,
} from '@gp/services/projectUpdate';
import moment from 'moment';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
import './index.scss';

// const RANGE_PICKER_TABS = [{ tabName: 'Month' }];
const RANGE_PICKER_TYPE = 'month';

interface ActionItemsFilterPropsType {
  loading: boolean,
  dateRange: [string, string],
  isDownloadBtnDisabled?: boolean;
  onChange: ((data: {startDate: string, endDate: string}) => void) | null,
  downloadParams: {
    selectDate: [string, string],
    sorts: SortBy<any>,
    selectStatus: string[],
    selectPhase: string[],
  },
}

const DEFAULT_PROPS: ActionItemsFilterPropsType = {
  loading: false,
  dateRange: ['', ''],
  isDownloadBtnDisabled: false,
  onChange: null,
  downloadParams: {
    selectDate: ['', ''],
    sorts: {
      by: 'due_date',
      order: 'asc',
    },
    selectStatus: ['1', '2', '3'],
    selectPhase: [],
  },
};

function ActionItemsFilter(props: ActionItemsFilterPropsType) {

  const {
    loading,
    dateRange,
    isDownloadBtnDisabled,
    onChange,
    downloadParams,
  } = props;

  const {
    projectDetailData,
  }: ContentType = useContext(context) || {};

  // const [dateType, setDateType] = useState('Month');
  const [dateValue, setDateValue] = useState<string[]>([]);

  const handleDateValueChange = useMemoizedFn((startDate, endDate) => {
    setDateValue([startDate, endDate]);
    onChange?.({
      startDate,
      endDate,
    });
  });

  // 默认值
  useEffect(() => {
    if (Array.isArray(dateRange) && dateRange?.length === 2) {
      setDateValue(dateRange);
    }
  }, [dateRange]);

  const isRangePickerDisabled = useMemo(() => {
    return !(dateRange?.[0] && dateRange?.[1]) || loading;
  }, [dateRange, loading]);

  /* const disabledDateRange = useMemo(() => {
    const startDate = dateRange?.[0];
    if (!startDate) return [];
    const startDateM = moment(startDate);
    if (!startDateM.isValid()) return [];
    const disabledEndDate = startDateM
      .startOf('month')
      .subtract(1, 'days')
      .format('YYYY-MM-DD');
    return ['1970-01-01', disabledEndDate];
  }, [dateRange]);

  const endYear = useMemo<string>(() => {
    const endDate = dateRange?.[1];
    const lastMonth = moment()
      .startOf('month')
      .subtract(1, 'months')
      .format('YYYY-MM-DD');
    if (!endDate) return lastMonth;
    const endDateM = moment(endDate);
    return !endDateM.isValid()
      ? lastMonth
      : endDateM.startOf('month').format('YYYY-MM-DD');
  }, [dateRange]); */

  const { isDownloading, handleDownload } = useDownload({
    csvDownloadLogKey: 'DETAIL_PROJECT_UPDATE_ACTION_LIST_CSV_DOWNLOAD_SUBMIT',
    excelDownloadLogKey: 'DETAIL_PROJECT_UPDATE_ACTION_LIST_EXCEL_DOWNLOAD_SUBMIT',
    downloadService: createDownloadService(actionItemsListDownLoad),
  });

  return (
    <section className="dbg-detail-project-update-action-items-filter search-item-date">
      {/* @ts-ignore */}
      {/* <RangePicker
        key={disabledDateRange?.[1]}
        className="gp-common-range-picker"
        disabled={isRangePickerDisabled}
        disables={disabledDateRange as [string, string]}
        endYear={endYear}
        range={true}
        headerTabShow={false}
        isAllOfTimeHidden={true}
        tabOptions={RANGE_PICKER_TABS}
        dateType={dateType}
        setDateType={setDateType}
        dateValue={dateValue}
        setDateValue={setDateValue}
        onChange={handleDateValueChange}
      /> */}
      <RangePicker
        type={RANGE_PICKER_TYPE}
        typeList={[RANGE_PICKER_TYPE]}
        value={dateValue}
        onChange={(value: any, type: string) => {
          handleDateValueChange(value?.[0], value?.[1]);
        }}
        disabled={isRangePickerDisabled}
        dateRange={dateRange}
      />
      <GeneralDownloadBtn
        style={{
          height: 34,
          width: 34,
          marginLeft: 10,
        }}
        isLoading={isDownloading}
        isDisabled={isDownloadBtnDisabled || isDownloading}
        fileTypes={FILE_TYPES2}
        onConfirm={(payload) => {
          const fileType = payload?.fileType || FILE_TYPES_MAP.CSV;
          handleDownload({
            fileType,
            file_type: Number.parseInt(fileType, 10),
            project_id: projectDetailData?.project_id,
            milestone: downloadParams?.selectPhase, // id数组
            start_date: downloadParams?.selectDate?.[0], // YYYY-MM-DD
            end_date: downloadParams?.selectDate?.[1], // YYYY-MM-DD
            order: downloadParams?.sorts?.order,
            status: downloadParams?.selectStatus || [],
          });
        }}
      />
    </section>
  );
}

ActionItemsFilter.defaultProps = DEFAULT_PROPS;

export default memo(ActionItemsFilter);
